import { Radio, Stack } from '@highlight-cp/core-ui';
import type { RadioGroupProps } from '@highlight-cp/core-ui';

export type GuidedStepRadioButtonGroupProps = RadioGroupProps;

/**
 * ### GuidedStepRadioButtonGroup
 *
 * @description
 * Pass-through to {@link Radio.Group} for guided-step card radio layouts. Use with
 * {@link GuidedStepRadioButton} (including `GuidedStepRadioButton.Large`) children.
 *
 * @example
 * <GuidedStepRadioButtonGroup value={value} onChange={setValue}>
 *   <GuidedStepRadioButton value="a" label="Option A" />
 *   <GuidedStepRadioButton.Row value="b" label="Option B" />
 * </GuidedStepRadioButtonGroup>
 *
 * @param props - {@link GuidedStepRadioButtonGroupProps}
 * @returns Radio group wrapper.
 */
export const GuidedStepRadioButtonGroup = ({
  children,
  ...rest
}: GuidedStepRadioButtonGroupProps) => {
  return (
    <Radio.Group {...rest}>
      <Stack gap="xs" mt="xs">
        {children}
      </Stack>
    </Radio.Group>
  );
};

GuidedStepRadioButtonGroup.displayName = 'GuidedStepRadioButtonGroup';
